import { FormattedEvent } from '@eventbrite/event-renderer';
import classNames from 'classnames';
import React from 'react';
import {
    GA_EXTERNAL_VIEW_EVENT_ACTION,
    GA_VIEW_EVENT_ACTION,
    GA_VIEW_MORE_ACTION,
} from '../../constants/analytics';
import { DiscoverVerticalEventCard } from '../DiscoverEventCard/Vertical/DiscoverVerticalBrowseEventCard';
import { SeeMoreButton } from '../SeeMoreButton';

const getCards = ({
    cards,
    isMobile,
    isAuthenticated,
    onTrackClick,
    onTrackClickInternal,
    affCode,
    locale,
}: {
    cards: FormattedEventWithStatsig[];
    locale: string;
    isMobile: boolean;
    isAuthenticated: boolean;
    onTrackClick: Function;
    onTrackClickInternal?: Function;
    affCode?: string;
}) => {
    const classes = classNames({
        'eds-g-cell eds-g-cell-3-12 eds-g-cell--has-overflow eds-l-pad-all-3':
            !isMobile,
        'small-card-mobile eds-l-pad-all-2': isMobile,
    });

    return cards.map(
        ({ id, statsigLocationString, ...cardProps }, index: number) => {
            return (
                <div className={classes} key={id}>
                    <DiscoverVerticalEventCard
                        locale={locale}
                        statsigLocationString={statsigLocationString}
                        event={{ ...cardProps, id }}
                        isAuthenticated={isAuthenticated}
                        affCode={affCode}
                        onClick={() => {
                            const action =
                                cardProps.ticketsBy === 'Eventbrite'
                                    ? GA_VIEW_EVENT_ACTION
                                    : GA_EXTERNAL_VIEW_EVENT_ACTION;
                            onTrackClick?.(
                                { id },
                                action,
                                cardProps.organizerFollowerCount,
                            );
                            onTrackClickInternal?.(
                                index,
                                id,
                                cardProps.ticketsBy,
                            );
                        }}
                    />
                </div>
            );
        },
    );
};

interface FormattedEventWithStatsig extends FormattedEvent {
    statsigLocationString: string;
}

export const SmallEventCardGroup = ({
    cards,
    linkUrl,
    isAuthenticated,
    onTrackClick,
    title,
    onTrackClickInternal,
    affCode,
    enableClientSideLinking,
    locale,
}: {
    cards: FormattedEventWithStatsig[];
    locale: string;
    linkUrl: string;
    isAuthenticated: boolean;
    onTrackClick: Function;
    title: string;
    onTrackClickInternal?: Function;
    affCode?: string;
    enableClientSideLinking?: boolean;
}) => (
    <div className="browse-cards-container">
        <div className="eds-show-up-md">
            {getCards({
                cards,
                locale,
                isMobile: false,
                isAuthenticated,
                onTrackClick,
                onTrackClickInternal,
                affCode,
            })}
        </div>
        <div className="eds-show-down-mn">
            <div className="mobile-card-carousel eds-l-mar-bot-4">
                {getCards({
                    cards,
                    isMobile: true,
                    isAuthenticated,
                    onTrackClick,
                    onTrackClickInternal,
                    affCode,
                    locale,
                })}
            </div>
            <div className="eds-show-down-sn eds-align--center">
                <div className="eds-g-cell">
                    <SeeMoreButton
                        linkUrl={linkUrl}
                        trackClick={onTrackClick}
                        title={title}
                        gaAction={GA_VIEW_MORE_ACTION}
                        enableClientSideLinking={enableClientSideLinking}
                    />
                </div>
            </div>
        </div>
    </div>
);

export default SmallEventCardGroup;
